import { novastar } from './novastar'
import { vaporwave } from './vaporwave'
import { professional } from './professional'
import { terminal } from './terminal'
import { daylight } from './daylight'
import { highContrast } from './highContrast'
import { normalizeThemeConfig } from './themeShape'

// Ordered list of built-in themes. Assignable ones appear in the admin story
// picker; highContrast is player-only (assignable: false).
export const BUILTIN_THEMES = [
  novastar,
  vaporwave,
  professional,
  terminal,
  daylight,
  highContrast,
].map(normalizeThemeConfig)

// id -> descriptor, for O(1) lookup in the resolver.
export const THEMES_BY_ID = Object.fromEntries(
  BUILTIN_THEMES.map((t) => [t.id, t]),
)

export const DEFAULT_THEME_ID = 'novastar'
export const HIGH_CONTRAST_ID = 'highContrast'

// The themes an admin can assign to a story (drives the story picker; the
// admin app keeps its own light copy of just id+name, but this is the source
// of truth for what's assignable).
export const ASSIGNABLE_THEMES = BUILTIN_THEMES.filter((t) => t.assignable)
